<template>
  <div id="success">
    <div class="success"></div>
    <h5>恭喜您，审核通过啦！</h5>
    <p>您已成功申请成为本协会
      <apply-name tag="span" /> 
      <br/><br/>
      请您尽快缴纳会费：
      <fee-amount tag="em" unit="元" />
      
    </p>
    <button class="btn-main btn-home" :class="{'disabled':!notice.length>0}" :disabled="!notice.length>0" @click="onPay()">
      去缴费
    </button>
    <div class="notice">
      <label>
        <input type="checkbox" name="checkbox" value="1" v-model="notice">
        <div class="hint">
          <i></i> 缴费前请阅读
        </div>
      </label>
      <span @click="isProtocolShow=true">《会费管理办法》</span>
    </div>
    <apply-modal
      v-show="isProtocolShow"
      category="MembershipFeeManagementMethod"
      @read="isProtocolShow=false"
    />
     
    <div class="bc" :class="{'active':isPayShow}" @click="onUnPay()"></div>
    <div class="pay-bc clearfix" :class="{'pay-active':isPayShow}">
      <div class="on-line">
        <router-link :to="{path:'/member/pay/online',query: {amount: payamount}}">
          <i></i>
          <span>线上支付</span>
        </router-link>
      </div>
      <div class="on-line off-line">
        <router-link :to="{path:'/member/pay/offline',query: {amount: payamount}}">
          <i></i>
          <span>线下支付</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import ApplyName from '@/components/member/ApplyName.vue';
import FeeAmount from '@/components/member/FeeAmount.vue';
import applyModal from "@/components/member/applyModal.vue";
  export default {
    components: {
      ApplyName,
      FeeAmount,
      applyModal
    },
    data() {
      return {
        notice: ['1'],
        isPayShow: false,
        isProtocolShow: false,
        payamount: 0,
        applyname: ""
      }
    },
    created() {  
    },
    methods: {
      onPay() {
        this.isPayShow = true;
      },
      onUnPay() {
        this.isPayShow = false;
      },
      openFeeModal() {
        this.isProtocolShow = true;
      },
      onUnProtocol() {
        this.isProtocolShow = false;
      }
       
    }
  };

</script>

<style lang="less" scoped>
  

  #success {
    height: 1334/@rem-size;
    max-height: 100%;
    background: #fff;
  }

  .success {
    width: 100%;
    height: 437/@rem-size;
    background: url('../../assets/images/success.png');
    background-size: 100% 100%;
  }

  h5 {
    font-size: 36/@rem-size;
    color: #333;
    margin-top: 24/@rem-size;
    font-weight: normal;
    text-align: center;
  }

  p {
    display: block;
    font-size: 28/@rem-size;
    text-align: center;
    margin-top: 24/@rem-size;
    padding: 0 24/@rem-size;
    color: #999;

    span {
      color: #333;
    }

    em {
      font-style: unset;
      color: #ff4f4f;
    }
  }

  .btn-home {
    display: block;
    width: 360/@rem-size;
    height: 80/@rem-size;
    text-align: center;
    line-height: 80/@rem-size;
    font-size: 36/@rem-size;
    margin: 0 auto;
    margin-top: 80/@rem-size;
    border-radius: 8/@rem-size;

    a {
      color: #fff;
    }
  }

  .bc {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    position: fixed;
    top: 0;
    left: 0;
    margin: auto;
    opacity: 0;
    transition: all 0.2s;
    z-index: -1;

    &.active {
      z-index: 1;
      opacity: 1;
    }
  }

  .pay-bc {
    width: 100%;
    height: 385/@rem-size;
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    padding-top: 120/@rem-size;
    transform: translate(0, 100%);
    transition: transform 0.2s, -webkit-transform 0.2s;
    z-index: 10;

    &.pay-active {
      transform: translate(0, 0);
    }
  }

  .on-line {
    width: 50%;
    float: left;

    i {
      display: block;
      width: 70/@rem-size;
      height: 70/@rem-size;
      background: url('../../assets/images/on-line.png');
      background-size: 100% 100%;
      margin: 0 auto;
    }

    span {
      display: block;
      color: #333;
      font-size: 28/@rem-size;
      text-align: center;
      margin-top: 25/@rem-size;
    }
  }

  .off-line {
    i {
      background: url('../../assets/images/off-line.png');
      background-size: 100% 100%;
    }
  }

  .notice {
    text-align: center;
    margin-top: 30/@rem-size;

    span {
      color: #005fd5;
    }

    label {
      display: inline-block;

      input[type="checkbox"] {
        -webkit-appearance: none !important;
        display: none;

        &:checked {
          +.hint {
            i {
              background-position: 0 0;
            }
          }
        }
      }

      .hint {
        font-size: 24/@rem-size;
        color: #999;
        padding-left: 55/@rem-size;
        position: relative;

        i {
          display: block;
          width: 32/@rem-size;
          height: 32/@rem-size;
          background: url('../../assets/images/hint-checkbox.png');
          background-size: 64/@rem-size 32/@rem-size;
          background-position: -32/@rem-size 0;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          margin: auto;
        }


      }
    }
  }

  .disabled {
    background: #999;
    box-shadow: none;
  }

  .protocol-bc {
    padding: 24/@rem-size;

    .protocol {
      width: 100%;
      overflow-y: scroll;
      background: #fff;
      max-height: 1075/@rem-size;

      .protocol-header {
        padding: 32/@rem-size 0 25/@rem-size;
        border-bottom: 1px solid #e5e5e5;

        h5 {
          padding: 0;
          margin: 0;
          font-size: 36/@rem-size;
          color: #333;
        }

        span {
          color: #999;
          font-size: 24/@rem-size;
          display: block;
          margin-top: 20/@rem-size;
          text-align: center;
        }
      }

      .protocol-main {
        padding-top: 18/@rem-size;
        padding-bottom: 40/@rem-size;

        span {
          display: block;
          font-size: 30/@rem-size;
          text-align: center;
        }

        p {
          padding: 0 18/@rem-size;
          text-align: left;
          font-size: 28/@rem-size;
          color: #333333;
          line-height: 40/@rem-size;
        }

        .account-info {
          font-size: 28/@rem-size;
          color: #333333;
          line-height: 40/@rem-size;
          padding: 0 18/@rem-size;

          span {
            text-align: left;
            font-size: 28/@rem-size;
            color: #333333;
            line-height: 40/@rem-size;
          }

          .info {
            span {
              float: left;
              max-width: 520/@rem-size;
            }
          }
        }
      }

      .protocol-footer {
        padding: 0 18/@rem-size;
        margin-top: 30/@rem-size;

        span {
          text-align: right;
          line-height: 42/@rem-size;
        }
      }
    }
  }

</style>
